/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { useToast } from '../../components/Toats';
import { LoadingSpan } from '../../components/Loadings/loadingSpan';
import { updateCoupon } from '../core/subscriptionService';
import { Coupon } from '../core/_models';
import { StepperComponent } from '../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../_metronic/helpers';

type Props = {
  coupon: Coupon | null;
  show: boolean;
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalToggleCoupon = ({ show, handleClose, coupon }: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const newStatus = (!coupon?.status || coupon.status === 'ATIVO') ? 'INATIVO' : 'ATIVO';
  const isDeactivating = newStatus === 'INATIVO';

  const toggleCouponSubmit = async () => {
    if (!coupon) return;
    try {
      setLoading(true)

      await updateCoupon(coupon.id, { status: newStatus } as any)
      toggleToast(`Sucesso ao ${isDeactivating ? 'desativar' : 'reativar'} o cupom.`, "success")

    } catch (error: any) {
      console.log('erro', error)
      toggleToast(error?.response?.data?.message || error?.response?.data?.error || `Erro ao ${isDeactivating ? 'desativar' : 'reativar'} o cupom.`, "error")
    } finally {
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    toggleCouponSubmit()
  }


  return createPortal(
    <Modal
      id='kt_modal_toggle_coupon'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{isDeactivating ? 'Desativar' : 'Reativar'} Cupom {" - "}{coupon ? coupon.code : "Não identificado"}</span>
        </h3>

        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_toggle_coupon_stepper'
        >


          {/*begin::Content */}
          <div className='flex-row-fluid py-lg-0'>
            <div style={{ marginBottom: '3rem' }}>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-semibold fs-5'>
                  {isDeactivating 
                    ? `Deseja realmente desativar o cupom "${coupon?.code}"? Ele ficará indisponível para novos pagamentos.` 
                    : `Deseja realmente reativar o cupom "${coupon?.code}"? Ele voltará a ficar disponível para uso no checkout.`}
                </span>
              </h3>
            </div>
            {/*begin::Form */}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button
                type='button'
                className='btn btn-lg btn-light'
                disabled={loading}
                onClick={() => {
                  closed()
                }}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr063.svg'
                  className='svg-icon-3 ms-2 me-0'
                />
                <span style={{ marginLeft: '0.5rem' }}>Cancelar</span>

              </button>

              <button
                type='button'
                className={`btn btn-lg ${isDeactivating ? 'btn-danger' : 'btn-success'}`}
                disabled={loading}
                onClick={submit}
              >
                {isDeactivating ? 'Desativar' : 'Reativar'}
                {
                  loading ?
                    <LoadingSpan style={{ marginLeft: '0.5rem' }} />
                    :
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-2 me-0'
                    />
                }
              </button>
            </div>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export { ModalToggleCoupon }
